export default __webpack_public_path__ + "static/media/Tree4.f83020a2.png";